export const getAppConfig = () => {
  if (typeof window !== "undefined" && window.__APP_CONFIG__) {
    return window.__APP_CONFIG__;
  }

  console.warn("APP_CONFIG not found. Using fallback.");

  return {
   defaultImage: "/img/finglider_logo.jpg",
  };
};